/* eslint-disable warp-drive/no-legacy-request-patterns */
import { service } from '@ember/service';
import Route from '@ember/routing/route';

import { hash } from '@linc-technologies/linced-common/utils/promise';
import PersonType from '@linc-technologies/linced-common/enums/person-type';

export default class AnalysisRoute extends Route {
  // Services
  @service
  store;

  model() {
    let post = this.modelFor('home.community-notices.notice');
    return hash({
      post,
      notificationResults: this.store.query('notifications/result', {
        entityId: post.id,
      }),
      learners: this.store.query('person', {
        type: PersonType.LEARNER,
        includeFormer: true,
      }),
      caregivers: this.store.query('person', { type: PersonType.CAREGIVER }),
    });
  }
}
